import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { _ } from "../utils/i18n";
import PropTypes from "prop-types";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: start;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    width: ${({ $sideMenu }) => ($sideMenu ? "100%" : "fit-content")};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    justify-content: center;
    order: 3;
    display: ${({ $sideMenu, $isPopUp }) =>
      $sideMenu ? "flex" : $isPopUp ? "flex" : "none"};
  }
  & .active {
    border-bottom: 2px solid var(--color-primary);
    font-family: var(--font-headings);
    background: var(--color-primary);
    color: var(--color-white);
  }
  &.popup {
    justify-content: center;
  }
`;
const Private = styled.button`
  width: ${({ $sideMenu }) => ($sideMenu ? "100%" : "120px")};
  height: 40px;
  background-color: ${({ $sideMenu }) =>
    $sideMenu ? "var(--color-white)" : "var(--color-accent3)"};
  border-radius: 1px 0 0 1px;
  color: var(--color-black);
`;
const Line = styled.div`
  width: 1px;
  height: 60%;
  border-right: 1px solid var(--color-primary);
  margin-inline: 1rem;
`;
const Business = styled.button`
  width: ${({ $sideMenu }) => ($sideMenu ? "100%" : "120px")};
  height: 40px;
  background-color: ${({ $sideMenu }) =>
    $sideMenu ? "var(--color-white)" : "var(--color-accent3)"};
  border-radius: 0 1px 1px 0;
  color: var(--color-black);
`;

const PrivateOrBusiness = ({ $sideMenu, $isPopUp }) => {
  const [privateOrBusiness, setPrivateOrBusiness] = useState(
    typeof window !== "undefined" && localStorage.getItem("private-business")
  );

  const handleClick = (POB) => {
    localStorage.setItem("private-business", POB);
    window.dispatchEvent(new Event("storage"));
  };

  const checkPrivateOrBusiness = () => {
    setPrivateOrBusiness(localStorage.getItem("private-business"));
  };

  useEffect(() => {
    window.addEventListener("storage", checkPrivateOrBusiness);
    return () => removeEventListener("storage", checkPrivateOrBusiness);
  }, []);

  if (privateOrBusiness === null && !$isPopUp) {
    return <></>;
  }

  return (
    <Wrapper
      $sideMenu={$sideMenu}
      $isPopUp={$isPopUp}
      className={$isPopUp ? "popup" : ""}
    >
      <Private
        $sideMenu={$sideMenu}
        aria-label="private"
        className={privateOrBusiness === "private" ? "active" : ""}
        onClick={() => handleClick("private")}
      >
        {_("Privat")}
      </Private>
      {$isPopUp && <Line />}
      <Business
        $sideMenu={$sideMenu}
        className={privateOrBusiness === "business" ? "active" : ""}
        aria-label="business"
        onClick={() => handleClick("business")}
      >
        {_("Bedrift")}
      </Business>
    </Wrapper>
  );
};

export default PrivateOrBusiness;

PrivateOrBusiness.propTypes = {
  $sideMenu: PropTypes.bool,
  $isPopUp: PropTypes.bool,
};
